import ICMAxios from '../ICMAxios';



const exportItemDataToExcel = async (cleintId: number) => {
    const response = await ICMAxios.get(`v1/Item/export`);
    return response.data;
};

const exportLocationDataToExcel = async (cleintId: number) => {
    const response = await ICMAxios.get(`v1/Location/export`);
    return response.data;
};

const exportUOMDataToExcel = async (cleintId: number) => {
    const response = await ICMAxios.get(`v1/UOM/export`);
    return response.data;
};

const MasterExportService = { exportItemDataToExcel, exportLocationDataToExcel, exportUOMDataToExcel }
export default MasterExportService;